import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { COLUMN_VALUE_DATE } from "../../model/OrdersTableDefinitionFactory.constants";

import { DateAdapter } from "../DateAdapter";

// String types that are sortable as an Int32 in C++ module
export class TenorAdapter extends DateAdapter {
  constructor() {
    super();
    this.localeString = "DD-MMM-YY";
  }

  retrieveData(order: any, columnProperty: string): string {
    var tenor: any = order.settleTenor;
    if (tenor) {
      return this.getTenorStr(tenor);
    }
    return super.retrieveData(order, COLUMN_VALUE_DATE);
  }

  retrieveSort(order: any, columnProperty: string): number {
    var tenor: any = order.settleTenor;
    if (tenor) {
      return order.settleTenor;
    }
    return super.retrieveSort(order, COLUMN_VALUE_DATE);
  }

  getTenorStr(tenor: CubiqTS.Tenor): string {
    switch (tenor) {
      case CubiqTS.Tenor.TDY:
        return "TDY";
      case CubiqTS.Tenor.TOM:
        return "TOM";
      case CubiqTS.Tenor.SPOT:
        return "SP";
      case CubiqTS.Tenor.W1:
        return "1W";
      case CubiqTS.Tenor.W2:
        return "2W";
      case CubiqTS.Tenor.W3:
        return "3W";
      case CubiqTS.Tenor.M1:
        return "1M";
      case CubiqTS.Tenor.M2:
        return "2M";
      case CubiqTS.Tenor.M3:
        return "3M";
      case CubiqTS.Tenor.M4:
        return "4M";
      case CubiqTS.Tenor.M5:
        return "5M";
      case CubiqTS.Tenor.M6:
        return "6M";
      case CubiqTS.Tenor.M7:
        return "7M";
      case CubiqTS.Tenor.M8:
        return "8M";
      case CubiqTS.Tenor.M9:
        return "9M";
      case CubiqTS.Tenor.M10:
        return "10M";
      case CubiqTS.Tenor.M11:
        return "11M";
      case CubiqTS.Tenor.Y1:
        return "1Y";
      case CubiqTS.Tenor.M13:
        return "13M";
      case CubiqTS.Tenor.M14:
        return "14M";
      case CubiqTS.Tenor.M15:
        return "15M";
      case CubiqTS.Tenor.M16:
        return "16M";
      case CubiqTS.Tenor.M17:
        return "17M";
      case CubiqTS.Tenor.M18:
        return "18M";
      case CubiqTS.Tenor.M19:
        return "19M";
      case CubiqTS.Tenor.M20:
        return "20M";
      case CubiqTS.Tenor.M21:
        return "21M";
      case CubiqTS.Tenor.M22:
        return "22M";
      case CubiqTS.Tenor.M23:
        return "23M";
      case CubiqTS.Tenor.Y2:
        return "2Y";
      case CubiqTS.Tenor.Y3:
        return "3Y";
      case CubiqTS.Tenor.Y4:
        return "4Y";
      case CubiqTS.Tenor.Y5:
        return "5Y";
      case CubiqTS.Tenor.SN:
        return "SN";
      case CubiqTS.Tenor.ALL:
        return "All";
    }
    return CubiqTS.Tenor[tenor];
  }
}
